import { RootGetterType } from '../interfaces';

export const GetterTypes: RootGetterType = {
    token: 'token',
    tokenTimestamp: 'tokenTimestamp',
    isIdentified: 'isIdentified',
    screeningUnit: 'screeningUnit',
    dataLoading: 'dataLoading',
    isLanguagesLoaded: 'isLanguagesLoaded',
    isAppLoaded: 'isAppLoaded',
    showErrInfoModal: 'showErrInfoModal',
    popUpErrMessage: 'popUpErrMessage',
    maxVisitedStepNumber: 'maxVisitedStepNumber',
    appVersion: 'appVersion',
    // Participant
    participant: 'participant',
    participantId: 'participantId',
    // Parameters
    useLongAppointment: 'useLongAppointment',
    useTRMGenderChoice: 'useTRMGenderChoice',
    allowFirstAppointment: 'allowFirstAppointment',
    // Appointment
    appointment: 'appointment',
    isFirstAppointment: 'isFirstAppointment',
    isRdvLong: 'isRdvLong',
    reasonLongAppointment: 'reasonLongAppointment',
    centerWithAvailabilities: 'centerWithAvailabilities',
    centerSelected: 'centerSelected',
    hasEventSelected: 'hasEventSelected',
    isBtnBackVisible: 'isBtnBackVisible',
    trmSex: 'trmSex',
    appID: 'appID',
    currentApt: 'currentApt',
    hasRdv: 'hasRdv',
    isAuthenticated: 'isAuthenticated',
    isDossierOpened: 'isDossierOpened',
    isRdvModified: 'isRdvModified',
};
